import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const MoveItemModal = ({ open, onClose, onSubmit, item = {}, tables = [] }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md")); // tablets/phones
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  const [quantity, setQuantity] = useState(item?.quantity ?? 1);
  const [targetTable, setTargetTable] = useState("");

  useEffect(() => {
    // reset when item or open changes
    setQuantity(item?.quantity ?? 1);
    setTargetTable("");
  }, [item, open]);

  const handleSubmit = () => {
    if (!targetTable) return alert("يرجى اختيار طاولة مستهدفة");
    onSubmit({
      item_id: Number(item.id),
      source_order_id: Number(item.order_id),
      quantity: Number(quantity),
      target_table: Number(targetTable),
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={fullScreen}
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 3 } }}
    >
      <DialogTitle sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 700 }}>
        نقل الصنف: {item?.product_name}
      </DialogTitle>

      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, px: { xs: 2, sm: 3 }, py: { xs: 1.5, sm: 2 } }}>
        <TextField
          label="الكمية"
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value) || 0)}
          size={isXs ? "small" : "medium"}
          inputProps={{ min: 1 }}
          fullWidth
          autoFocus
        />
        <FormControl fullWidth size={isXs ? "small" : "medium"}>
          <InputLabel>اختر الطاولة</InputLabel>
          <Select
            value={targetTable}
            label="اختر الطاولة"
            onChange={(e) => setTargetTable(e.target.value)}
          >
            <MenuItem value="">
              <em>-- اختر طاولة --</em>
            </MenuItem>
            {tables.map((table) => (
              <MenuItem key={table.id} value={table.id}>
                {`طاولة ${table.name}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: { xs: 1.5, sm: 1 }, flexDirection: { xs: "column-reverse", sm: "row" }, gap: { xs: 1, sm: 0 } }}>
        <Button onClick={onClose} sx={{ width: { xs: "100%", sm: "auto" } }}>إلغاء</Button>
        <Button onClick={handleSubmit} variant="contained" sx={{ width: { xs: "100%", sm: "auto" } }}>
          نقل
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveItemModal;
